import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (p) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'MODiFY_YIELD',
    method: 'PUT',
  });
  useEffect(() => {
    if (p) {
      exec({ url: `/api/yield_saved`, data: p });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p]);
  return [isRequestSuccessed, exec];
});
